<template>
  <v-list-tile
    :href="type == 'phone' ? `tel:${subTitle}` : type == 'email' ? `mailto:${subTitle}` : ''"
    :slot="activator ? 'activator' : ''"
  >
    <v-list-tile-action v-if="noAvatar">
      <v-icon :color="color">{{icon}}</v-icon>
    </v-list-tile-action>
    <v-list-tile-avatar v-else>
      <v-icon :class="`${color} white--text`">{{icon}}</v-icon>
    </v-list-tile-avatar>

    <v-list-tile-content>
      <v-list-tile-title class="body-2">{{title}}</v-list-tile-title>
      <v-list-tile-sub-title>{{subTitle || '-'}}</v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    icon: String,
    color: String,
    title: String,
    subTitle: String,
    type: String,
    noAvatar: Boolean,
    activator: Boolean
  }
};
</script>

<style>
</style>
